import {ValueObject} from '@s-ui/domain'

import {SpecificationVehiclesValueObject} from './SpecificationVehiclesValueObject.js'

export class KmSpecificationVehiclesValueObject extends ValueObject {
  #km

  constructor({km}) {
    super()
    this.#km = km
  }

  static KM_SUFFIX = 'km'

  static empty() {
    return new KmSpecificationVehiclesValueObject({km: SpecificationVehiclesValueObject.empty()})
  }

  static kmString({km}) {
    return `${km} ${KmSpecificationVehiclesValueObject.KM_SUFFIX}`
  }

  static createFromId({id}) {
    if (!SpecificationVehiclesValueObject.isValidId({id})) return KmSpecificationVehiclesValueObject.empty()

    return new KmSpecificationVehiclesValueObject({
      km: SpecificationVehiclesValueObject.createFromLiterals({
        id,
        name: KmSpecificationVehiclesValueObject.kmString({km: id})
      })
    })
  }

  get icon() {
    return this.#km.icon
  }

  get id() {
    return this.#km.id
  }

  get name() {
    return this.#km.name
  }

  get value() {
    return this.#km.value
  }

  isEmpty() {
    return this.#km.isEmpty()
  }
}
